import { render } from "./SharepointApp.vue?vue&type=template&id=5fad5d90&scoped=true"
import script from "./SharepointApp.vue?vue&type=script&lang=js"
export * from "./SharepointApp.vue?vue&type=script&lang=js"

import "./SharepointApp.vue?vue&type=style&index=0&id=5fad5d90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fad5d90"]])

export default __exports__